import packageInfo   from '../../../package.json'; //new added for release note
import Cookies from "js-cookie";
export const APP_VERSION:any = packageInfo.version; 

export const getUserMail = () => {
    try {
        const userMail:any = Cookies.get('details');
        const {email}=JSON.parse(userMail);
        return email
    } catch (error) {
        console.error("Error parsing or retrieving cookie:", error);
    }
 }



export function toTitleCase(str:any) {
  if(str !== null )
    {
      return str.replace(
        /\w\S*/g,
        function(txt:any) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    }
}


export function csvTargetSlNormalize(targetStoploss: any) {
  let target = 0
  let stoploss: any = 0
  let targetValue: any = false
  let stoplossValue: any = false
  let newTslArray: any = []

  if (targetStoploss?.length > 0) {
    var tslObj: any = {}
    targetStoploss.reverse().map((item: any) => {
      if ((item['Target'] !== null && item['Target'] !== undefined) && (targetValue == false)) {
        target = item['Target']
        targetValue = true
      }
      if (item['Stoploss'] !== null && item['Stoploss'] !== undefined && (stoplossValue == false)) {
        stoploss = item['Stoploss']
        stoplossValue = true
      }
      tslObj = { "Time": item['time'] }
      if (item['Target'] !== undefined) {
        tslObj = ({ ...tslObj, 'Target': item['Target'] })
      }
      if (item['Stoploss'] !== undefined) {
        tslObj = ({ ...tslObj, 'Stoploss': item['Stoploss'] })
      }
      newTslArray.push(tslObj)
    })
  }
  return { "Target": target, "Stoploss": stoploss, "TargetStoplossJson": JSON.stringify(newTslArray?.reverse()) }
}


export function backdatedCSVTargetSlNormalizer(targetStoploss:any){
  let target = 0
  let stoploss: any = 0
  let targetValue: any = false
  let stoplossValue: any = false

  if(targetStoploss && Object?.keys(targetStoploss)?.length > 0){
      Object.keys(targetStoploss).reverse()?.map((item:any) => {
          if((targetStoploss[item]['Target'] !== null) && (targetStoploss[item]['Target'] !== undefined) && (targetValue === false)){
              target = targetStoploss[item]['Target']
              targetValue = true
          }
          if((targetStoploss[item]['Stoploss'] !== null) && (targetStoploss[item]['Stoploss'] !== undefined) && (stoplossValue === false)){
              stoploss = targetStoploss[item]['Stoploss']
              stoplossValue = true
          }
      })
  }

  return {"Target" : target, "Stoploss" : stoploss, "TargetStoplossJson": JSON.stringify(targetStoploss)}
}